@if (Vendor) {
  <div class="container-fluid mt-4 ps-4">
    <div class="row">
      <div class="col-12">
        <div class="row justify-content-between">
          <div class="col-10">
            <h2>Insurance - {{ Vendor.legalName }}</h2>
          </div>
          @if (archivedInsuranceCerts) {
            <div class="col-2">
              <div class="form-check">
                <label class="form-check-label"
                  >Show archived?
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="showArchived"
                /></label>
              </div>
            </div>
          }
        </div>
        <div class="row g-4 pb-3">
          @if (showArchived) {
            <h3 class="pt-1">Active Policies</h3>
            <hr class="m-0" />
          }
          @if (insuranceCerts.length > 0) {
            @for (cert of insuranceCerts; track cert) {
              @for (policy of cert.InsurancePolicies; track policy) {
                @if (shouldShowPolicyType(policy.policyType!)) {
                  <div class="col-12 col-md-4 insurance-card">
                    <app-display-card
                      [panelHeight]="'fit'"
                      [header]="
                        policyNameMap.get(policy.policyType!) ||
                        policy.policyType
                      "
                      [innerPanel]="true"
                    >
                      <div
                        class="insurance-content d-flex flex-column align-items-center"
                      >
                        <div
                          class="status fs-24 fw-semibold"
                          appStatusStyleChanges
                        >
                          {{ getPolicyStatus(policy) | uppercase }}
                        </div>
                        <div class="policyNumber py-1 fw-semibold">
                          Policy Name: {{ policy.policyNumber }}
                        </div>
                        <div class="agentName py-1 fw-semibold">
                          Agent Name:
                          {{ cert.agentFirstName + ' ' + cert.agentLastName }}
                        </div>
                        <div class="expirationDate py-1 fw-semibold">
                          Expiration Date:
                          {{ policy.expirationDate | date: 'MM/dd/y' }}
                        </div>
                        @if (cert.id) {
                          <!-- <button class="btn btn-primary my-1" (click)="viewCOI(cert.id)">View COI</button> -->
                          <button
                            class="btn btn-primary my-1"
                            (click)="download(cert)"
                          >
                            Download COI
                          </button>
                        }
                      </div>
                    </app-display-card>
                  </div>
                }
              }
            }
          }
          @if (missingRequiredInsurancePolicies) {
            @for (policy of missingRequiredInsurancePolicies; track policy) {
              <div class="col-12 col-md-4 insurance-card h-100">
                <app-display-card [header]="policy.displayName">
                  <div class="inner-panel rounded text-center h-100">
                    <span
                      class="status fs-24 fw-semibold"
                      appStatusStyleChanges
                      >{{ policy.status }}</span
                    >
                  </div>
                </app-display-card>
              </div>
            }
          }
          @if (exemptInsurancePolicies) {
            @for (policy of exemptInsurancePolicies; track policy) {
              <div class="col-12 col-md-4 insurance-card h-100">
                <app-display-card [header]="policy.displayName">
                  <div class="inner-panel rounded text-center h-100">
                    <span
                      class="status fs-24 fw-semibold"
                      appStatusStyleChanges
                      >{{ policy.status }}</span
                    >
                  </div>
                </app-display-card>
              </div>
            }
          }
        </div>
        @if (showArchived) {
          <div class="row pb-3">
            <h3 class="pt-3">Archived Policies</h3>
            <hr />
            <div ngbAccordion [closeOthers]="false">
              @for (item of archivedInsuranceCertsByYear; track item) {
                <div ngbAccordionItem>
                  <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>{{ item.year }}</button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <div class="col-12">
                          <div class="row g-4">
                            @for (
                              cert of item.archivedInsuranceCerts;
                              track cert
                            ) {
                              @for (
                                policy of cert.InsurancePolicies;
                                track policy
                              ) {
                                @if (shouldShowPolicyType(policy.policyType!)) {
                                  <div
                                    class="col-12 col-md-4 insurance-card grayScale"
                                  >
                                    <app-display-card
                                      [panelHeight]="'fit'"
                                      [header]="
                                        policyNameMap.get(policy.policyType!) ||
                                        policy.policyType
                                      "
                                      [innerPanel]="true"
                                    >
                                      <div
                                        class="insurance-content d-flex flex-column align-items-center"
                                      >
                                        <div
                                          class="status fs-24 fw-semibold"
                                          appStatusStyleChanges
                                        >
                                          {{
                                            getPolicyStatus(policy) | uppercase
                                          }}
                                        </div>
                                        <div
                                          class="policyNumber py-1 fw-semibold"
                                        >
                                          Policy Name: {{ policy.policyNumber }}
                                        </div>
                                        <div class="agentName py-1 fw-semibold">
                                          Agent Name:
                                          {{
                                            cert.agentFirstName +
                                              ' ' +
                                              cert.agentLastName
                                          }}
                                        </div>
                                        <div
                                          class="expirationDate py-1 fw-semibold"
                                        >
                                          Expiration Date:
                                          {{
                                            policy.expirationDate
                                              | date: 'MM/dd/y'
                                          }}
                                        </div>
                                        @if (cert.id) {
                                          <!-- <button class="btn btn-primary my-1" (click)="viewCOI(cert.id)">View COI</button> -->
                                          <button
                                            class="btn btn-primary my-1"
                                            (click)="download(cert)"
                                          >
                                            Download COI
                                          </button>
                                        }
                                      </div>
                                    </app-display-card>
                                  </div>
                                }
                              }
                            }
                          </div>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
